// import type { Response } from '@/service/types'
import type { country } from './types'
// import { getResponse } from "@/service/utils";
// import { getEnvConfig } from "@/service/config/UrlConfig";
import countryList from '../../data/countryList.json'

export class countryService {
  async getCountries(): Promise<{ data: country[] }> {
    const countries = countryList.data.filter((account: any) => {
      return account.status === true && account.blockType != 'bloqueado'
    })

    return { data: countries }
  }
}
